import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Toast } from 'antd-mobile';
import { UserOutline, LockOutline } from 'antd-mobile-icons';
import axiosInstance from '../axiosInstance';
import './Login.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // 创建 FormData 对象
      const formData = new FormData();
      formData.append('grant_type', 'password');
      formData.append('username', values.username);
      formData.append('password', values.password);

      // 设置请求头
      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      };

      // 将 FormData 转换为 URLSearchParams
      const urlEncodedData = new URLSearchParams();
      formData.forEach((value, key) => {
        urlEncodedData.append(key, value);
      });

      const response = await axiosInstance.post('/auth/token', urlEncodedData, config);

      if (response.data.access_token) {
        localStorage.setItem('access_token', response.data.access_token);
        // 可以根据需要存储其他返回的数据
        if (response.data.refresh_token) {
          localStorage.setItem('refresh_token', response.data.refresh_token);
        }
        Toast.show({
          icon: 'success',
          content: '登录成功'
        });
        navigate('/');
      } else {
        throw new Error('Token not received');
      }
    } catch (error) {
      let errorMessage = '登录失败';

      // 处理不同的错误情况
      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMessage = '用户名或密码错误';
            break;
          case 401:
            errorMessage = '未授权访问';
            break;
          case 403:
            errorMessage = '访问被禁止';
            break;
          default:
            errorMessage = `服务器错误 (${error.response.status})`;
        }
      } else if (error.request) {
        errorMessage = '网络请求失败，请检查网络连接';
      }

      Toast.show({
        icon: 'fail',
        content: errorMessage
      });
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">欢迎回来</h2>
        <Form
          layout="vertical"
          onFinish={onFinish}
          footer={
            <Button
              block
              type="submit"
              color="primary"
              size="large"
              loading={loading}
            >
              登录
            </Button>
          }
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名！' }]}
          >
            <Input prefix={<UserOutline />} placeholder="用户名" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码！' }]}
          >
            <Input
              prefix={<LockOutline />}
              type="password"
              placeholder="密码"
            />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;